import Template from '@/pages/Manage/Template'
import Manage from '@/pages/Manage/ManageSet'
import ManageShop from '@/pages/ManageShop'
import Orders from '@/pages/Manage/Orders'
import ManageItems from '@/pages/Manage/Items'
import ManageItem from '@/pages/Manage/Item'
import ManageOrder from '@/pages/ManageOrder'
import ManageCustomers from '@/pages/Manage/Customers'
import ManageLists from '@/pages/Manage/Lists'
import ManageShoppingList from '@/pages/Manage/ShoppingList'
import ManageMarketList from '@/pages/Manage/MarketList'

export default {
    path: '',
    component: Template,
    children: [
      // {
      //   path: '/manage/:id',
      //   name: 'Manage Set',
      //   component: Manage
      // },
      {
        path: 'shop/:ref',
        name: 'Manage Shop',
        component: ManageShop
      },
      {
        path: '/manage/items',
        name: 'Manage Items',
        component: ManageItems
      },
      {
        path: '/manage/items/:ref',
        name: 'Manage Item',
        component: ManageItem
      },
      {
        path: 'orders',
        name: 'Manage Orders',
        component: Orders
      },
      {
        path: 'order/:ref',
        name: 'Manage Order',
        component: ManageOrder,
      },
      {
        path: '/manage/customers',
        name: 'Manage Customers',
        component: ManageCustomers
      },
      {
        path: '/manage/lists',
        name: 'Manage Lists',
        component: ManageLists
      },
      {
        path: '/manage/lists/shopping/:ref',
        name: 'Shopping List',
        component: ManageShoppingList
      },
      {
        path: '/manage/lists/market/:ref',
        name: 'Market List',
        component: ManageMarketList
      },
    ]
}



// WEBPACK FOOTER //
// ./src/router/manage.js